/* eslint-disable max-len */
export const sections = [
  {
    name: 'service',
    header: 'Amplifier Maintenance and Repair',
    photo: 'https://i.imgur.com/8WK1xSP.jpg',
    blurb: 'Our goal is to provide a great sounding, reliable repair that is fast and affordable',
    info: 'Amphead maintains an extensive stock of the best quality amp parts to get repairs done right and turned around quickly. We stock the best current production tubes: JJ Electronic, Sovtek, Tung Sol and others. When we perform a retube at Amphead,  the preamp tubes are selected by ear for each position as it performs in your amp. Output tubes are biased using both current draw and crossover distortion methods. Lets talk about your sound and get your amp set up right.  New tubes are burned in to eliminate factory defects and assure reliability.  Tubes purchased and installed at Amphead are guaranteed for 3 months.',
    listInfo: [],
    figures: []
  },
  {
    name: 'guitar',
    header: 'Guitar Service',
    photo: 'https://i.imgur.com/mgtsDvm.jpg',
    blurb:'Amphead provides quality electric guitar service. Repair, custom electronics and set up.',
    info: 'Amphead has always provided quality guitar service. Set up, wiring and repair. Amphead stocks new tuning machines, knobs, replacement bridges and bridge parts, strap pegs and strap locks, and all the best quality electronic parts; controls, jacks, switches and capacitors.',
    listInfo: [],
    figures: []
  },
  {
    name: 'overhaul',
    header: 'Tube Amp Overhaul',
    photo: '/assets/mullard-tube.jpeg',
    blurb:'Many of the most popular amps today are 25+ years old and are well beyond their expected service life. Eventually that sweet vintage tube amp will need to be "overhauled" to produce good tone and stay off the repair bench',
    info: 'Many of the most popular amps today are 25+ years old and are well beyond their expected service life. Eventually that sweet vintage tube amp will need to be "overhauled" to produce good tone and stay off the repair bench.   An overhaul is not a repair. The overhaul process is maintenance for amps that are past their life expectancy. Your amp probably doesn\'t need an overhaul unless it is over 20 years old and has not been maintained or is unused for an extended time.   An overhaul returns your old amp to original specs, includes functional analysis of all circuits and replacing the known failure parts that have not been previously replaced.',
    listInfo: ['A complete "cap job" that includes replacing all the electrolytic filter and bypass capacitors and any faulty or suspect tone and coupling capacitors.', 'A complete re-tube.', 'A new AC cable if needed', 'Replacement or repair of all defective, noisy, worn or suspect switches, jacks, controls, tube sockets and other parts subject to physical and elemental wear.', 'Cleaning and corrosion protection of all tube sockets, jacks, controls, connectors and switches.', 'Check and replace out of spec and noisy plate, grid and power supply dropping resistors.', 'Service the reverb pan and cables', 'Straighten bent chassis as needed', 'Replace missing or damaged hardware and tighten loose fasteners.', 'Check the speakers and speaker wiring and service as needed.', 'An overhaul is completed with the burning in of new output tubes, selection of pre-amp tubes and tuning of function and tone quality.', 'All components in an overhaul carry the Amphead 90 day guarantee.'],
    figures: []
  },
  {
    name: 'modification',
    header: 'Tube Amp Modification',
    photo: '/assets/wires.jpeg',
    blurb: 'Dial in Your Sound Amphead performs proven custom performance upgrades for classic tube guitar amps.',
    info: 'With a properly serviced amp; upgrading tubes, speakers and other components can improve tone quality. There are also preferred circuits that can be referenced to "back date" your amplifier and popular non-factory circuit changes to customize the function and tone of your amplifier. \n Previous changes can be re-done to return your amp to stock.',
    listInfo: ['Marshall -Most tube amps, current and  vintage', ' Vintage Fender', 'Fender Hot Rod Series, Blues series and re-issues', 'Mesa bias control '],
    figures: []
  },
  {
    name: 'restoration',
    header: 'Tube Amp Restoration',
    photo: 'https://i.imgur.com/qHBtT9o.jpg',
    blurb: 'This \'59 Fender Bassman is an example of a restoration project completed at Amphead in July of \'06. Click for details and pictures of the process.',
    info: '* This 1959 Fender Bassman has seen more action than most of us around today.\n* Since the amp had been previously recovered it was a good candidate for a full restoration.',
    listInfo: [],
    figures: [{
      imageUrl: 'https://i.imgur.com/TIwpbhZ.jpg',
      figCaption: 'The tweed look tolex and grill where very worn.'
    },
    {
      imageUrl: 'https://i.imgur.com/lPupTeO.jpg',
      figCaption: 'The chassis was rusty and had broken welds.'
    },
    {
      imageUrl: 'https://i.imgur.com/Mh4Dkt2.jpg',
      figCaption: 'The back pannels had been replaced with plywood.'
    },
    {
      imageUrl: 'https://i.imgur.com/xBSZBAB.jpg',
      figCaption: 'The welds repaired and rust removed preserving the original printing.'
    },
    {
      imageUrl: 'https://i.imgur.com/wtjWtcM.jpg',
      figCaption: 'New back pannels, logo and hardware.'
    },
    {
      imageUrl: 'https://i.imgur.com/qHBtT9o.jpg',
      figCaption: 'The amp came out nice and the owner, Rich Layton, was happy.'
    }]
  },
  {
    name: 'gen-info',
    header: 'General Info',
    photo: 'https://i.imgur.com/BqiMcmJ.jpg',
    blurb: '',
    info: 'Service bench cost is $100 per hour. The schedule varies with the workload. Please contact us for current turnaround times. Let us know your situation, we can usually accommodate. Rush service, when available, is $60.',
    listInfo: [],
    figures: [],

  }
];
